/**
 * Accordion Component
 *
 * Handles expand/collapse with smooth animation,
 * keyboard navigation, and accessibility state sync.
 */
(function () {
    'use strict';

    function initAccordions() {
        var triggers = document.querySelectorAll('.c-accordion__trigger');

        triggers.forEach(function (trigger) {
            trigger.addEventListener('click', function () {
                toggleItem(this);
            });

            trigger.addEventListener('keydown', function (event) {
                handleKeydown(event, this);
            });
        });
    }

    /**
     * Toggle an accordion item.
     */
    function toggleItem(trigger) {
        var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        var panelId = trigger.getAttribute('aria-controls');
        var panel = document.getElementById(panelId);

        if (!panel) {
            return;
        }

        if (isExpanded) {
            closePanel(trigger, panel);
        } else {
            openPanel(trigger, panel);
        }
    }

    /**
     * Open a panel with animation.
     */
    function openPanel(trigger, panel) {
        trigger.setAttribute('aria-expanded', 'true');
        panel.removeAttribute('hidden');
        panel.style.maxHeight = panel.scrollHeight + 'px';

        panel.addEventListener('transitionend', function handler() {
            panel.style.maxHeight = '';
            panel.removeEventListener('transitionend', handler);
        });
    }

    /**
     * Close a panel with animation.
     */
    function closePanel(trigger, panel) {
        panel.style.maxHeight = panel.scrollHeight + 'px';

        // Force reflow before animating closed.
        void panel.offsetHeight;

        panel.style.maxHeight = '0';
        trigger.setAttribute('aria-expanded', 'false');

        panel.addEventListener('transitionend', function handler() {
            panel.setAttribute('hidden', '');
            panel.style.maxHeight = '';
            panel.removeEventListener('transitionend', handler);
        });
    }

    /**
     * Handle keyboard navigation between accordion triggers.
     */
    function handleKeydown(event, trigger) {
        var accordion = trigger.closest('.c-accordion');

        if (!accordion) {
            return;
        }

        var triggers = Array.from(
            accordion.querySelectorAll('.c-accordion__trigger')
        );
        var index = triggers.indexOf(trigger);
        var target = null;

        switch (event.key) {
            case 'ArrowDown':
                event.preventDefault();
                target = triggers[(index + 1) % triggers.length];
                break;
            case 'ArrowUp':
                event.preventDefault();
                target = triggers[(index - 1 + triggers.length) % triggers.length];
                break;
            case 'Home':
                event.preventDefault();
                target = triggers[0];
                break;
            case 'End':
                event.preventDefault();
                target = triggers[triggers.length - 1];
                break;
        }

        if (target) {
            target.focus();
        }
    }

    // Initialise when DOM is ready.
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAccordions);
    } else {
        initAccordions();
    }
})();
